module.exports = __webpack_public_path__ + "static/media/group_3@3x.f3379f70.png";